import { Queue } from './queue';

export const createImageUploadQueue = (options: {
    maxParallelLightUploads: number;
    maxParallelHeavyUploads: number;
}) => {

    const lightQueue = new Queue(options.maxParallelLightUploads);
    const heavyQueue = new Queue(options.maxParallelHeavyUploads);

    const enqueue = <T>(task: () => Promise<T>, isMemoryHeavy: boolean): Promise<T> => {
        return isMemoryHeavy
            ? heavyQueue.enqueue(task)
            : lightQueue.enqueue(task);
    };

    return { enqueue };
};

export const isMemoryHeavyImage = (width: number, height: number) => {
    const MEMORY_USAGE_PER_PIXEL_IN_BIT = 8; // https://github.com/dlemstra/Magick.NET/tree/main/docs#q8-q16-or-q16-hdri
    const HEAVY_MEMORY_USAGE_THRESHOLD_IN_BIT = 838860800; // 100 MB
    return width * height * MEMORY_USAGE_PER_PIXEL_IN_BIT >= HEAVY_MEMORY_USAGE_THRESHOLD_IN_BIT;
};